import Vue from "vue";
import SelectObject from "./main.vue";

const Constructor = Vue.extend(SelectObject);

let object: any;

export default {
  showSelectObject(params: any) {
    if (!object) {
      const div = document.createElement("div");
      document.body.appendChild(div);
      object = new Constructor({
        el: div
      });
    }
    object.show(params);
  }
};

